module.exports = __webpack_public_path__ + "img/cm.5ef78df8.svg";